import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { CompanyActionContext } from '../../../common/types/CompanyActionContext';
import {
  WEB_COMPONENT_COMPANY_LICENSING_TAB,
  WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB,
  WEB_COMPONENT_COMPANY_DETAILS_TAB,
  WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB,
  WEB_COMPONENT_PLANS_AND_PURCHASE_TAB,
} from '../../../../webcomponents.constants';

export const templateMyCompanyPanel = document.createElement('template');

templateMyCompanyPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <gz-tab-group class="my-company-tab-group" id="my-company-tab-group">
      <gz-tab id="company-details-tab" route="/my-company">
        <${WEB_COMPONENT_COMPANY_DETAILS_TAB} context='${CompanyActionContext.MyCompany}'></${WEB_COMPONENT_COMPANY_DETAILS_TAB}>
      </gz-tab>
      <gz-tab id="authentication-tab" route="/my-company/authentication">
        <${WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB} context='${CompanyActionContext.MyCompany}'></${WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB}>
      </gz-tab>
      <gz-tab id="licensing-tab" route="/my-company/licensing">
        <${WEB_COMPONENT_COMPANY_LICENSING_TAB} context='${CompanyActionContext.MyCompany}'></${WEB_COMPONENT_COMPANY_LICENSING_TAB}>
      </gz-tab>
      <gz-tab id="plans-and-purchase-tab" route="/my-company/purchase" hidden>
        <${WEB_COMPONENT_PLANS_AND_PURCHASE_TAB} context='${CompanyActionContext.MyCompany}'></${WEB_COMPONENT_PLANS_AND_PURCHASE_TAB}>
      </gz-tab>
      <gz-tab id="beta-programs-tab" route="/my-company/early-access" hidden>
        <${WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB} context='${CompanyActionContext.MyCompany}'></${WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB}>
      </gz-tab>
    </gz-tab-group>
  </div>
`;
